import { ORDER_STATUS_TYPE } from '@/api/type/commonTypes';
import { Images } from '@/assets';
import SpeechBubble from '@/components/bubble/SpeechBubble';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface RejectedStatusProps {
  status: ORDER_STATUS_TYPE;
  rejectionReason?: string;
}
const RejectedStatus = ({ status, rejectionReason }: RejectedStatusProps) => {
  const [openBubble, setOpenBubble] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <Container>
      <Section>
        <StatusDot $status={status} />
        {t('reject')}
      </Section>
      <BubbleSection
        onMouseEnter={() => setOpenBubble(true)}
        onMouseLeave={() => setOpenBubble(false)}
      >
        <RejectReasonButton />
        {openBubble && rejectionReason && (
          <BubbleWrap>
            <SpeechBubble
              title={t('reasonForRejection')}
              desc={rejectionReason}
            />
          </BubbleWrap>
        )}
      </BubbleSection>
    </Container>
  );
};

export default RejectedStatus;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Section = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const StatusDot = styled.div<{ $status: ORDER_STATUS_TYPE }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${({ $status }) => {
    switch ($status) {
      case 'PENDING':
        return '#FFC400';
      case 'IN_PROGRESS':
        return '#21B837';
      case 'CANCELLED':
        return '#393C3C';
      case 'REJECTED':
        return '#393C3C';
      case 'COMPLETED':
        return '#DBDBDB';
      default:
        return '#E5E5E5';
    }
  }};
  border: ${({ $status }) =>
    $status === 'COMPLETED' ? `1px solid #F2F2F2` : 'none'};
`;

const BubbleSection = styled.div`
  position: relative;
`;

const RejectReasonButton = styled.button`
  width: 27px;
  height: 27px;
  background-image: url(${Images.StatusRejectIcon});
  background-size: cover;
  &[data-selected='true'] {
    background-image: url(${Images.StatusRejectIcon});
  }
`;

const BubbleWrap = styled.div`
  position: absolute;
  top: -15px;
  left: 60px;
  z-index: 9999;
`;
